module.exports = __webpack_public_path__ + "media/images/musician_home-b8714615d54500ab1348ce219a50de2b.png";